import { getClientTraceHeaders } from "./clientTraceHeaders";

type LogClientPayload = {
  action: string;
  description: string;
  endpoint?: string;
  method?: string;
  userId?: number | null;
  additionalData?: Record<string, unknown>;
};

/**
 * Отправка диагностики на backend (POST /api/error-log).
 * Не бросает наружу — сбой логирования не должен ломать UX.
 */
export function logClientDiagnostic(payload: LogClientPayload): void {
  try {
    const body = {
      error: {
        name: "ClientDiagnostic",
        message: payload.description,
        stack: "",
        code: null,
      },
      endpoint: payload.endpoint || "/client/diagnostic",
      method: payload.method || "CLIENT",
      userInfo: {
        type: "user",
        id: payload.userId ?? null,
        tg_id: null,
        email: null,
        username: null,
      },
      context: {
        source: "client",
        action: payload.action,
        description: payload.description,
      },
      request: {
        body: {},
        query: {},
        params: {},
        headers: {
          ...getClientTraceHeaders(),
        },
      },
      response: { status: 0, data: null },
      additionalData: {
        href: typeof window !== "undefined" ? window.location.href : null,
        ...payload.additionalData,
      },
    };

    void fetch("/api/error-log", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        ...getClientTraceHeaders(),
      },
      credentials: "include",
      body: JSON.stringify(body),
    }).catch(() => {});
  } catch {
    // ignore
  }
}
